<script lang="ts">
	import { PUBLIC_BASE_URL } from '$env/static/public';
  import { browser } from "$app/environment";
  import { GtmStore } from '$lib/utils/gtm-store';
  import { StructureUtils } from '$lib/utils/structured-utils';
  import type { PageData } from "./$types";
  import { customPageOptions } from '$lib/utils/layout-store';
	import { goto } from '$app/navigation';
	import { handleUrlClientSide } from '$lib/utils/assets-utils';
  // Components
  import { Head } from '$lib/components/atoms/Head'
  import { Breadcrumb, BreadcrumbItem } from '$lib/components/molecules/Breadcrumb';
  import { Section, SectionTight } from '$lib/components/organisms/Section';
  import { ScrollableCardWrapper } from '$lib/components/organisms/Layout';

  export let data: PageData;
  const { partner, partnerLinkedCourses, partnerTotalCourses } = data;

  customPageOptions({bodyStyle: 'gray'});

  if (!partner) {
    goto('/');
  }

  /******************** GTM EVENT PUSH *************************/
  GtmStore.pushEvent({
    pageCategory: 'Network - Partner',
    label: data?.partner?.name ? data.partner.name : ''
  });
  /*************************************************************/

  const breadcrumbJson = StructureUtils.getBreadcrumbStructure(
    [
      {
        name: 'Home',
        url: PUBLIC_BASE_URL,
      },
      {
        name: 'Partners',
        url: `${PUBLIC_BASE_URL}partners`,
      },
    ],
    true
  );

  let ldScriptTag = '';
  if (!browser) {
    ldScriptTag = StructureUtils.createScriptTag(JSON.stringify([breadcrumbJson]));
  }

  const seoDetails = {
    title: `Partner ${partner.name ? partner.name : ''}`,
    description: `${partner.name ? partner.name : ''}, un nostro partner di eccellenza`,
    url:  `/partners/${partner.slug ? partner.slug : ''}`,
    ldScriptTag: ldScriptTag,
  };
</script>

<Head appendCompany {seoDetails} />

<Breadcrumb disableLastElementLink>
  <BreadcrumbItem>
    <a href="/">Home</a>
  </BreadcrumbItem>
  <BreadcrumbItem>
    <a href="/partners">Partners</a>
  </BreadcrumbItem>
  <BreadcrumbItem current>
    <a href="/partners/{partner.slug}">{partner.name}</a>
  </BreadcrumbItem>
</Breadcrumb>

<SectionTight variant="transparent" class="bg-gray-50 py-6 lg:py-12" tighter>
  <div class="image-container">
    <img
      width="200"
      height="170"
      class="partner-card-img"
      src={handleUrlClientSide(partner.imageUrl)}
      alt={partner.name}
    />
  </div>
</SectionTight>

{#if partnerLinkedCourses.length > 0 && partnerTotalCourses > 0}
  <Section class="py-6 md:py-14 bg-white">
    <svelte:fragment slot="header">
      <p class="subtitle v-small mb-2">Corsi correlati</p>
      <h3>Scopri i percorsi che hanno {partner.name} come partner</h3>
    </svelte:fragment>
    <ScrollableCardWrapper courses={partnerLinkedCourses} />
  </Section>
{/if}

<style type="text/scss" lang="scss" scoped>
  .image-container {
    @apply shadow-card;
    width: 200px;
    height: 200px;
    padding: 20px;
    justify-content: center;
    display: flex;
    background: white;
  }

  .image-container img {
    object-fit: contain;
    width: 100%;
    height: auto;
  }
</style>